// @flow

import { Fragment } from 'react';
import styled from 'styled-components';
import { Dialog } from '@blueprintjs/core';
import ThumbnailWithStatelemsSingleImageDisplayer from '../thumbnail-image-with-statelems-displayer-menu/thumbnail-with-statelems-single-image-displayer';
import { ThumbnailWithLocationNameWithStatelems } from '../../models/query-response';

const ImageContainer = styled.div``;

const ImagesWrapper = styled.div`
  margin: 0 1rem;

  ${ImageContainer} {
    margin-bottom: 1rem;
  }

  ${ImageContainer}:first-child {
    margin-top: 1rem;
  }

  ${ImageContainer}:last-child {
    margin-bottom: 0;
  }
`;

type Props = {
  setMetricPreviewImagesForModal: (recordings: string[]) => void,
  previewImages?: ThumbnailWithLocationNameWithStatelems[],
};

const LocationThumbnailWithStatelemsTableMenu = ({
  setMetricPreviewImagesForModal,
  previewImages
}: Props) => {
  const isLocationThumbnailOpen = previewImages && previewImages.length > 0;
  return (
    <Fragment>
      <Dialog
        icon="camera"
        isOpen={isLocationThumbnailOpen}
        onClose={() => setMetricPreviewImagesForModal([])}
        title="All preview images"
      >
        <ImagesWrapper>
          {previewImages &&
            previewImages.length > 0 &&
            previewImages.map((thumb, i) => (
              <ImageContainer key={i}>
                <ThumbnailWithStatelemsSingleImageDisplayer key={i} thumb={thumb} />
              </ImageContainer>
            ))}
        </ImagesWrapper>
      </Dialog>
    </Fragment>
  );
};

export default LocationThumbnailWithStatelemsTableMenu;
